import crudActions from '../../crud/actions'

const actions = crudActions('SETTINGS_BASIC_LISTS_')

export default actions
